import { __require as require_getNative } from './_getNative.js';
import { __require as require_root } from './_root.js';

var _Map;
var hasRequired_Map;

function require_Map () {
	if (hasRequired_Map) return _Map;
	hasRequired_Map = 1;
	var getNative = require_getNative(),
	    root = require_root();

	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');

	_Map = Map;
	return _Map;
}

export { require_Map as __require };
//# sourceMappingURL=_Map.js.map
